package com.rainbowclubs.rainbow.presentation.admin

import com.rainbowclubs.rainbow.data.models.UserRole

data class AdminUiState(
    val role: UserRole,
    val ongoingEventId: String?,
)
